import { Input } from "antd";
import styled from "styled-components";

export const NumberInput = styled(Input)`
    input.ant-input { text-align: center; }
`